/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Font_Family_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Font Family Selection" |
*
* @param {Styles_Font_Family_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_font_family_aria_label = /** @type {((inputs?: Styles_Font_Family_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Font_Family_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selection de police")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schriftfamilienauswahl")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezione della famiglia di caratteri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбор семейства шрифтов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selección de la familia de fuentes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字体系列选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォントファミリーの選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉन्ट परिवार का चयन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleção de Família de Fontes")
	return /** @type {LocalizedString} */ ("Font Family Selection")
});